import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SaveCancelService {
  private disabledState$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  public setDisabledState(newState: boolean): void {
    this.disabledState$.next(newState);
  }

  public getDisabledState(): Observable<boolean> {
    return this.disabledState$ as Observable<boolean>;
  }
}
